import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AppComponent } from '../../app.component';
import { AuthenticationService } from '../../services/authentication.service';
import { AppMenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  standalone: true,
  imports: [CommonModule, AppMenuComponent]
})
export class TopBarComponent {
  constructor(
    public app: AppComponent,
    private authenticationService: AuthenticationService
  ) {}

  login() {
    this.authenticationService.login();
  }

  logout() {
    this.authenticationService.logout();
  }

  get authenticated(): boolean {
    return this.authenticationService.isAuthenticated;
  }

  get LoggedInUserName(): string {
    return this.authenticationService.email;
  }
}
